// Environment configuration
export const ENV = {
  // GraphQL URL - defaults to production
  GRAPHQL_URL: import.meta.env.VITE_GRAPHQL_URL || 'http://localhost:8000/graphql',
  PROD_URL: import.meta.env.VITE_PROD_URL || 'https://api.zekitec.com.br',
} as const;

export const INTERCOM_APP_ID = 'gf55fxab';
